import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import media from 'src/styles/Media.styled';
import { isMobileDevice } from 'src/utils/util';
import { sizes } from 'src/styles/Media.styled';
import useWindowSize from 'src/common/components/getWindowSize';
import i18n from 'src/i18n.js';
 const t = (key) => i18n.t(key);

const AlertText = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: ${(props) => (props.fontSize ? props.fontSize : '13px')};
    letter-spacing: -0.1px;
    color: ${(props) => (props.color ? props.color : '#ED002A')};
    opacity: 1;
    padding: ${(props) => props.padding};
    line-height: ${(props) => props.lineHeight};
    ${media.mobileDevice`
        font-size: ${(props) => props.mbFontSize};
    `}
`;
const HeaderText = styled.div`
    font-family: 'AvenirNextWorld Demi';
    display: inline;
    font-size: ${(props) => (props.fontSize ? props.fontSize : '13px')};
    letter-spacing: -0.1px;
    color: ${(props) => (props.color ? props.color : '#ED002A')};
    opacity: 1;
    padding: ${(props) => props.padding};
    ${media.mobileDevice`
        font-size: ${(props) => props.mbFontSize};
    `}
`;

const AlertMsg = ({
    header,
    message,
    fontSize,
    mbFontSize,
    mbHeight,
    mbWidth,
    lineHeight,
    imageMargin,
    linkedSstref,
    vendorCaseErrorRedirection,
    lotSerial,
    padding,
    alignItems,
    isAlertBundle,
    marginLeft,
    isReplenish
}) => {
    const val = ` ${t('reportUsage.progressBar.Billingstatement')} ${lotSerial} ${t('reportUsage.progressBar.verifystatement')} ${t('reportUsage.progressBar.clickherestatement')} `;
    const formatMsg = (msg) => {
        if (!isMobileDevice() && msg == val) {
            return (
                <>
                    {` ${t('reportUsage.progressBar.Billingstatement')} ${lotSerial}`}
                    <br />
                    {
                        t('reportUsage.progressBar.verifystatement')
                    }
                    <br />
                    {t('reportUsage.progressBar.clickherestatement')}
                </>
            );
        }
        return message;
    };
    const [winWidth] = useWindowSize();
    const isMobileView = winWidth < sizes.smalDevice;
    const ipadMini = winWidth === sizes.smalDevice;
    const isIpadAir = winWidth >= 818 && winWidth <= 824;
    const isLanguageChanged = useSelector(state => state.loginReducer.isLanguageChanged);
    return (
        <div
            style={{
                display: isIpadAir && isLanguageChanged ? 'block' : 'flex',
                marginLeft: marginLeft
                    ? marginLeft
                    : isMobileView
                    ? '0px'
                    : isAlertBundle && winWidth >= 760 && winWidth <= 800
                    ? '20px !important'
                    : isAlertBundle
                    ? '0px' : ipadMini ? '20px'
                    : isReplenish? '-60px':'20px',
                alignItems: alignItems,
            }}
        >
            <img
                src={AlertCircleOutline}
                height={mbHeight ? mbHeight : '16px'}
                width={mbWidth ? mbWidth : '16px'}
                style={{ margin: imageMargin ? imageMargin : '2px 6px 0 0' }}
            />

            <AlertText
                fontSize={fontSize}
                mbFontSize={mbFontSize}
                lineHeight={lineHeight}
                padding={padding}
            >
                {header && (
                    <HeaderText mbFontSize={mbFontSize}>{header}</HeaderText>
                )}
                {formatMsg(message)}
                {linkedSstref && (
                    <HeaderText
                        id={`header-text-${linkedSstref}`}
                        style={{
                            color: '#1010EB',
                            cursor: 'pointer',
                            // margin:  '0px 0 8px 40px'
                        }}
                        onClick={() =>
                            vendorCaseErrorRedirection(
                                linkedSstref,
                                true,
                                false
                            )
                        }
                    >
                        {linkedSstref}
                    </HeaderText>
                )}
            </AlertText>
        </div>
    );
};

export default AlertMsg;
